document.addEventListener("DOMContentLoaded", () => {
  const animationDuration = 1000;
  const animationTimingFunc = "cubic-bezier(0.4, 0, 0.2, 1)";
  let navOpen = false;
  let header = document.querySelector(".js-header");
  let navTrigger = document.querySelector(".js-nav-trigger");
  let nav = document.querySelector(".js-nav");
  let backdrop = document.querySelector(".js-nav-backdrop");
  let main = document.querySelector(".js-main");

  // add toggle class names to any element with [blur-content]
  const toggleBackgroundBlurs = () => {
    document.querySelectorAll("[blur-content]").forEach((v) => {
      v.classList[navOpen ? "add" : "remove"]("blur-sm", "opacity-50");
    });
  };

  // Toggle navigation class names / state
  const toggleNavTriggerState = () => {
    document
      .querySelector(".js-nav-trigger-strip-1")
      .classList[navOpen ? "add" : "remove"](
        "-translate-y-0.5",
        "-rotate-45",
        "bg-white!"
      );
    document
      .querySelector(".js-nav-trigger-strip-2")
      .classList[navOpen ? "add" : "remove"]("translate-x-6", "opacity-0");
    document
      .querySelector(".js-nav-trigger-strip-3")
      .classList[navOpen ? "add" : "remove"](
        "translate-y-0.5",
        "rotate-45",
        "bg-white!"
      );
  };

  // Initiate all tippy elements
  tippy("[data-tippy-content]");

  // Toggle navigation class names / state
  const toggleNavState = () => {
    nav.classList[navOpen ? "add" : "remove"]("top-16");
    nav.classList[navOpen ? "remove" : "add"]("top-full");
  };

  // Toggle header class names / state
  const toggleHeaderState = () => {
    header.classList[navOpen ? "add" : "remove"]("pb-8");
  };

  // Add click event to nav trigger
  navTrigger.addEventListener("click", (e) => {
    navOpen = !navOpen;
    toggleBackgroundBlurs();
    toggleNavTriggerState();
    toggleNavState();
    toggleHeaderState();
  });

  // Initiate sitewide Glide carousels
  const initGlideCarousels = () => {
    const carouselClasses = [".js-glide-content-asset", ".js-glide-features"];

    carouselClasses.forEach((v) => {
      document.querySelectorAll(v).forEach((instance) => {
        if (v == ".js-glide-content-asset") {
          const carousel = new Glide(instance, {
            animationDuration: animationDuration,
            animationTimingFunc: animationTimingFunc,
            type: "slider",
            perView: 1,
            autoHeight: true,
            gap: 20,
          });

          carousel.mount({
            GlideAutoHeight: GlideAutoHeight,
          });
        }

        if (v == ".js-glide-features") {
          const glide = new Glide(instance, {
            animationDuration: animationDuration,
            animationTimingFunc: animationTimingFunc,
            type: "carousel",
            perView: 3,
            gap: 100,
            breakpoints: {
              1200: {
                gap: 60,
              },
              1080: {
                perView: 2,
              },
              768: {
                perView: 1,
                gap: 0,
              },
            },
          });

          glide.mount();
        }
      });
    });
  };

  // Add GlideAutoHeight to resize Glide carousel slides when changed
  function GlideAutoHeight(Glide, Components, Events) {
    const Component = {
      mount() {
        if (!Glide.settings.autoHeight) return;
        Components.Html.track.style.transition =
          "height 1000ms cubic-bezier(0.4, 0, 0.2, 1)";
        this.updateTrackHeight();
      },

      updateTrackHeight() {
        if (!Glide.settings.autoHeight) return;

        const activeSlides = Components.Html.slides.filter((slide, index) => {
          return (
            index >= Glide.index &&
            index <= Glide.index - 1 + Glide.settings.perView
          );
        });

        const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
          return Math.max(maxHeight, slide.offsetHeight);
        }, 0);

        const glideTrack = Components.Html.track;
        if (newMaxHeight !== glideTrack.offsetHeight) {
          glideTrack.style.height = `${newMaxHeight}px`;
        }
      },
    };

    Events.on("run", () => {
      Component.updateTrackHeight();
    });
    Events.on("update", () => {
      Component.updateTrackHeight();
    });
    Events.on("resize", () => {
      Component.updateTrackHeight();
    });

    return Component;
  }

  initGlideCarousels();
});
